import { useTranslation } from "react-i18next";
import { IOptions } from "components/sideMenu/SideMenu";

export default function SettingOptionsTranslation() {
  const { t } = useTranslation();

  const customerOptions: IOptions[] = [
    {
      label: t("All Customers"),
      url: "/admin/customers", //auto-route
    },
    {
      label: t("Public"),
      url: "/admin/customers-public",
    },
    {
      label: t("Sold Memberships"),
      url: "/admin/customers-member",
    },

    {
      label: t("Credit Books"),
      url: "/admin/customers-credit-books",
    },
  ];

  return customerOptions;
}
